import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { PreviousPaperModel } from '../../../../models/ExamModels/PreviousPaperModel/previouspaper.model';
import { PaginationModel } from '../../../../models/PaginationModel/pagination.model';
import { PreviousPaperService } from '../../../../services/ExamService/PreviousPaperService/previouspaper.service';
// import AnalyticsCard from '../../../../shared/components/AnalyticsComponents/AnalyticsCard';
import AppHeader from '../../../../shared/components/AppHeader';
import ListAnalyticsSubjectCards from '../ListAnalyticsSubjectCards';

const ListPaperAnalytics: FC = () => {
    const [papers, setPapers] = useState<any[]>([])
    const [meta,setMeta] = useState<any>()
    const {state} : {state:any} = useLocation()
    const fetchPapers = () => {
        PreviousPaperService.fetchPreviousPaper(
            10,
            (response: PreviousPaperModel[], meta: PaginationModel) => {
              setPapers(response);
              setMeta(meta);
              console.log(response);
            },
            (error: any) => {}
          );
    }
    useEffect(() => {
        fetchPapers()
    }, [])
    return(
        <>
            {/* <AnalyticsCard/> */}
            <ListAnalyticsSubjectCards
            subjects={papers}
            showProgress={false}
            onClick={() => {}}
            />
        </>
    )
}
export default ListPaperAnalytics